import $ from 'jquery';

let searchBarWrapper = $( '.header__search-form' );
let searchInput      = $( '.header__search-form input[type=text]' );

$( document ).on( 'click', '.menu-item.search', function ( e ) {
	e.preventDefault();
	if ( searchBarWrapper.hasClass( 'visible' ) ) {
		searchBarWrapper.removeClass( 'visible' );
		searchInput.val( '' );
	} else {
		searchBarWrapper.addClass( 'visible' );
		searchInput.focus();
	}
} );